/* eslint-disable react/prop-types */
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ScreenLoader from '../components/ScreenLoader';
import { StyledProvider } from '../vNext/theme';
import lazy from '../util/lazyLoading';

const LoginScreen = lazy(() => import('../screens/LoginScreen'));
const NotFoundPage = lazy(() => import('../vNext/pages/NotFoundPage/NotFoundPage'));

export default () => (
    <Routes>
        <Route
            path="/login"
            element={ (
                <ScreenLoader>
                    <LoginScreen />
                </ScreenLoader>
            ) }
        />
        <Route
            path="*"
            element={ (
                <ScreenLoader>
                    <StyledProvider publicationID={ CONFIG.myPage.publication }>
                        <NotFoundPage />
                    </StyledProvider>
                </ScreenLoader>
            ) }
        />
    </Routes>
);
